export enum TaskDetailTabEnum {
  /**Действия */
  Actions = 0,
  /**История изменений */
  History = 1,
  /**Комментарии */
  Comments = 2,
}